// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ce-iframe{margin:0 auto;overflow:hidden;padding:0;max-width:61.25em}.ce-iframe iframe{border:none;box-shadow:none;min-height:1050px;width:100%}@media screen and (min-width:810px){.ce-iframe iframe{min-height:1200px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
